import styles from "./auth-page.module.css";
import { useEffect, useState } from "react";
import { Auth } from "@supabase/auth-ui-react";
import { useAuthContext } from "BEDROCK/auth/auth-provider";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { usePaths } from "BEDROCK/paths";
import { ResetPasswordPage } from "./reset-password-page";
import { useAnalyticsTracker } from "analytics-tracker";

interface AuthPageProps {}

export const AuthPage = (props: AuthPageProps) => {
  const { session, client: supabaseClient } = useAuthContext();
  const { home, auth, navigateTo } = usePaths();
  const [isRecovery, setIsRecovery] = useState(false);
  const [loading, setLoading] = useState(true);
  const { trackEvent } = useAnalyticsTracker();

  useEffect(() => {
    const hashParams = new URLSearchParams(window.location.hash.slice(1));
    const type = hashParams.get("type");

    const checkSession = async () => {
      if (supabaseClient) {
        const { data } = await supabaseClient.auth.getSession();
        setIsRecovery(type === "recovery");
        setLoading(false);
      }
    };

    checkSession();
  }, [supabaseClient]);

  useEffect(() => {
    // Clean up the URL after auth
    supabaseClient?.auth.getSession().then(() => {
      if (window.location.hash.includes("access_token")) {
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        );
      }
    });
  }, [supabaseClient]);

  useEffect(() => {
    if (session) {
      trackEvent("User Signed In");
      navigateTo(home);
    }
  }, [session, trackEvent, navigateTo, home]);

  if (loading) return null;

  if (isRecovery) {
    return <ResetPasswordPage />;
  }

  if (session) {
    navigateTo(home);
  }

  const redirect = process.env.REACT_APP_BASE_REDIRECT_URL + auth;
  return (
    <div className={styles.container}>
      <div className={styles.innerContainer}>
        <InfoBox />
        <div className={styles.formContainer}>
          <Auth
            supabaseClient={supabaseClient!}
            providers={["google", "apple"]}
            onlyThirdPartyProviders={false}
            redirectTo={redirect}
            appearance={{
              theme: ThemeSupa,
              variables: {
                default: {
                  colors: {
                    brand: "#ff5476", // primary buttons
                    brandAccent: "#ff5476", // hover/focus color
                    inputBorder: "#e5e5e5",
                    inputBackground: "#f7f7f7",
                    messageText: "#21211f",
                    anchorTextColor: "#ff5476",
                  },
                  radii: {
                    borderRadiusButton: "8px",
                    inputBorderRadius: "6px",
                  },
                  fontSizes: {
                    baseBodySize: "15px",
                    baseInputSize: "14px",
                  },
                },
              },
            }}
          />
        </div>
      </div>
    </div>
  );
};

const InfoBox = () => {
  return (
    <div className={styles.instructionContainer}>
      <span>
        <b>Sign in</b> or <b>create an account</b> to access the admin dashboard
      </span>
    </div>
  );
};
